import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import MultiSelect, { MultiSelectProps } from 'components/MultiSelect';

import { RoomPropertySelect_data$key } from '__generated__/RoomPropertySelect_data.graphql';

type Props = {
  data: RoomPropertySelect_data$key;
} & MultiSelectProps;

type MakeLabelRoomProperty = {
  name: string | null;
  etgKey: string | null;
};

export const makeLabel = ({ name, etgKey }: MakeLabelRoomProperty) => {
  if (name && etgKey) {
    return `${name} [${etgKey}]`;
  }

  if (name) {
    return name;
  }

  if (etgKey) {
    return `[${etgKey}]`;
  }

  return '[nėra pavadinimo]';
};

const RoomPropertySelect: FC<Props> = ({ data, ...rest }) => {
  const { roomProperties } = useFragment(
    graphql`
      fragment RoomPropertySelect_data on Query {
        roomProperties(first: 2147483647) {
          edges {
            node {
              id
              name
              icon
              etgKey
            }
          }
        }
      }
    `,
    data
  );

  return (
    <MultiSelect
      {...rest}
      options={
        roomProperties?.edges.map(({ node: { id, icon, ...rest } }) => ({
          id,
          icon,
          name: makeLabel(rest),
        })) ?? []
      }
    />
  );
};

export default RoomPropertySelect;
